import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

const getPosReports = async (bpid, sid = '', pageSize = 200, page = '', filter = '', orderBy = '') => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/posreports?siteId=${sid}&pageSize=${pageSize}&pageToken=${page}&filter=${filter}&orderBy=${orderBy}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const getPosReportById = async (bpid, prid) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/posreports/${prid}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const createPosReport = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/posreports`;

  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => res.json());
};

const deletePosReport = async (bpid, prid) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/posreports/${prid}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'DELETE'
  }).then(res => API.generateResponse(res));
};

const getProducts = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}/products`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const uploadPosFile = async (uploadUrl, file) => {
  await API.refreshTokenWhenNeeded();
  return fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      ...API.headers,
      'X-Request-Id': crypto.randomUUID(),
      'Content-Type': 'application/octet-stream'
    },
    body: file
  }).then(res => res.status);
};

export { getPosReports, getPosReportById, createPosReport, deletePosReport, getProducts, uploadPosFile };
